<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Item Master Data</h4>
                <p class="text-subtitle-1"></p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-1">
            <v-col cols="12" md="3">
                <v-btn  depressed block  @click="navigateToEditItem" v-if="hasPermission(perm.item.update)">
                    <v-icon left>mdi-pencil</v-icon>
                    edit
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs v-model="tab0">
                    <v-tab>Overview</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs-items v-model="tab0">
                    <v-tab-item>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-sheet outlined>
                                    <v-img
                                        v-ripple
                                        @click="imageDisplayDialog = true"
                                        contain
                                        max-height="250"
                                        :src="imageUrl"
                                    ></v-img>
                                </v-sheet>
                                <v-btn block class="my-1" @click="uploadImageDialog = true" v-if="hasPermission(perm.item.update)">
                                    <v-icon left>mdi-upload</v-icon>
                                    upload image
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="8">
                                <Item :value="data" v-if="!loading"/>
                                <ItemLoader class="pa-3" v-else/>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-tabs v-model="tab" height="65">
                    <v-tab>Measure Units</v-tab>
                    <v-tab>Accounts</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-toolbar flat dense>
                            <v-spacer></v-spacer>
                            <v-btn @click="navigateItemMeasureUnit" depressed color="primary">
                                <v-icon>mdi-plus</v-icon>
                                attach measure unit
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <ItemMeasureUnitList :data="data" :loading="loading"/>
                    </v-tab-item>
                    <v-tab-item>
                        <v-toolbar flat dense>
                            <v-spacer></v-spacer>
                            <v-btn @click="handleAttachAccount" depressed color="primary">
                                <v-icon>mdi-plus</v-icon>
                                attach account
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <ItemAccountList :data="data" :loading="loading"/>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
        <v-dialog v-model="uploadImageDialog" max-width="400">
            <ItemImageUpload
                v-if="uploadImageDialog"
                @cancel="uploadImageDialog = false"
                @uploading-image="uploadingImage = $event"
                @uploaded="onImageUploaded"
                :itemId="id"/>
        </v-dialog>
        <v-dialog v-model="imageDisplayDialog" >
            <v-sheet rounded color="black">
                <v-img
                    max-height="80vh"
                    contain
                    :src="imageUrl"
                ></v-img>
            </v-sheet>
        </v-dialog>
    </v-container>
</template>

<script>
import permissions from "./../../data/permissions"
import ItemMeasureUnitList from "./../../components/warehouse/ItemMeasureUnitList.vue"
import ItemAccountList from "./../../components/warehouse/ItemAccountList.vue"
import Item from './../../components/warehouse/Item';
import ItemLoader from './../../components/warehouse/ItemLoader';
import PAlert from './../../components/common/PAlert';
import { mapActions } from 'vuex';
import ItemImageUpload from './../../components/warehouse/ItemImageUpload.vue';
import { v4 as uuid } from 'uuid';
import { baseUrl } from './../../config/endpoints'
import authorize from '../../utils/authorize';

export default {
    name: "ItemDisplayView",
    components: {
        PAlert,
        Item,
        ItemAccountList,
        ItemMeasureUnitList,
        ItemLoader,
        ItemImageUpload
    },
    data() {
        return {
            data: null,
            id: null,
            alert: {
                value: false,
            },
            loading: false,
            tab: 0,
            tab0: 0,
            perm: permissions,
            uploadImageDialog: false,
            uploadingImage: false,
            imageUuid: uuid(),
            imageDisplayDialog: false
        }
    },
    computed: {
        ItemAccounts() {
            return this.data ? this.data.accounts : []
        },
        ItemMeasureUnits() {
            return this.data ? this.data.measure_units : [] 
        },
        imageUrl() {
            return `${baseUrl}/item-image/images/${this.id}.png?uuid=${this.imageUuid}`
        }
    },
    methods: {
        ...mapActions({
            findByID: "stock/item/findByID",
            snackbar: "ui/snackbar/show",
        }),
        hasPermission(code) {
            return authorize(code)
        },
        navigateToEditItem() {
            this.$router.push({ name: "ItemEdit", params: { id: this.id } })
        },
        navigateItemMeasureUnit() {
            this.$router.push({name: "ItemMeasureUnitCreate", params: { id : this.id } })
        }, 
        getItem() {
            this.loading = true
            this.findByID(this.id).then(response => {
            this.data = response.data 
            }).catch(error => {
            let message = error.response ? error.response.data.message : error
            this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({name: "ItemList"})
        },
        handleAttachAccount() {
            this.$router.push({ name: "ItemAccountCreate", params: { id : this.id } })
        },
        onImageUploaded() {
            this.imageUuid = uuid();
            this.uploadImageDialog = false;
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getItem()
        switch(this.$route.query.tab) {
            case "measure_units":
                this.tab = 0;
                break;
            case "accounts":
                this.tab = 1;
                break;
            default:
                this.tab = 0;
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getItem();
        next()
    }
}
</script>

<style>

</style>